// extracted by mini-css-extract-plugin
module.exports = {"barLabel":"task-list_barLabel__3DIN3","barLabelOutside":"task-list_barLabelOutside__3SUjy","productLabel":"task-list_productLabel__w_ujY"};